<nb-card class="order-card">
	<nb-card-body>
		<div class="details-body">
			<div class="card-header-wrapper">
				<div class="card-header" [ngClass]="{'collapsed': !detailsVisible}">
					<h5 class="company-name">{{ companyName }} </h5>
					<change-label [visible]="isCompanyNameChanged()" [changeSet]="changeSet"></change-label>
				</div>
				@if (collapsable) {
					<a id="toggle-order-details" class="toggle-details-section" (click)="detailsVisible = !detailsVisible" data-test-id="order-details-toggle">
						{{ (detailsVisible ? 'common.hide' : 'common.show') | translate }}
						<nb-icon icon="{{detailsVisible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
					</a>
				}
			</div>

			@if (detailsVisible) {
				<div id="order-details" class="row-wrapper">
					<div class="col-md-12">
						<address-details [order]="order" [changeSet]="changeSet" [showMultiSiteQuestion]="!isRecertification()"></address-details>
						<contact-person-details [contactPerson]="order.contactPerson" [changeSet]="changeSet"></contact-person-details>
						@if (withProductDetails) {
							@for (product of order.products; track $index) {
								<product-details [order]="order" [product]="product" [changeSet]="changeSet" [showCertificateQuestion]="!isRecertification()"
												 [showPriceFactorTooltips]="showPriceFactorTooltips" [translateClientsData]="translateClientsData"
												 [useOriginalTranslations]="useOriginalTranslations"></product-details>
							}
						}
					</div>
				</div>
			}

			@if (editable) {
				<div class="change-button" [ngClass]="{'collapsed': !detailsVisible}">
					<button id="change-button" nbButton status="warning" outline (click)="basicInfoChangeRequested.emit()">{{ 'common.edit' | translate }}</button>
				</div>
			}

		</div>
	</nb-card-body>
</nb-card>
